module.exports = __webpack_public_path__ + "img/clip-start-up.49b18f03.png";